<osp-toast key="osp-toast" #toast>
  <ng-template let-message>
    <div class="toast" [ngClass]="message.severity === 'neutral' ? 'toast--neutral' : ''">
      @if (message.severity === 'error') {
        <osp-icon [icon]="IconKey.RootToastError | icon" class="toast__icon--error"></osp-icon>
      }
      @if (message.severity === 'success') {
        <osp-icon [icon]="IconKey.RootToastSuccess | icon" class="toast__icon--success"></osp-icon>
      }
      @if (message.severity === 'warn') {
        <osp-icon [icon]="IconKey.RootToastWarn | icon" class="toast__icon--warn"></osp-icon>
      }
      @if (message.severity === 'neutral') {
        <osp-icon [icon]="IconKey.RootToastNeutral | icon" class="toast__icon--neutral"></osp-icon>
      }
      <div class="toast__message-container">
        <p class="text-sm text-color font-semibold toast__summary">{{ message.summary }}</p>
        <p class="text-xs text-color font-semibold toast__detail">{{ message.detail }}</p>
        @if (message.severity === 'error') {
          <p class="text-xs text-color toast__support">{{ 'shared.errorSnackbar.contactSupport' | translate }}</p>
          <p class="text-xs text-color toast__error-time">
            {{ 'shared.errorSnackbar.timeOfFailure' | translate }}:
            {{ message.data.errorTime | formatDateTime: { showTime: true } }}
          </p>
        }
        @if (message.actions?.length) {
          <div class="toast__actions">
            @for (action of message.actions; track action.label; let first = $first) {
              <osp-button
                [label]="action.label"
                [category]="first ? 'secondary' : 'ghost'"
                (onClick)="runAction(action, message)"
              />
            }
          </div>
        }
      </div>

      <osp-icon
        ospClickable
        [icon]="IconKey.GlobalClose | icon"
        (onClick)="dismiss(message)"
        (onKeyDown)="handleCloseKeyDown($event, message)"
        class="toast__close-icon"
      />
    </div>
  </ng-template>
</osp-toast>
